
import { Component, OnInit, Inject, ElementRef, NgZone, ViewChild } from '@angular/core';
import { DealershipService } from '../services/dealership.service';
import { DealershipOverview, ColourScheme, BrandedStyleDetails } from '../models/dealership.model';
import { CustomerServiceIdentity } from '../services/customer.service';
import { ReportStyle, NewCustomer } from '../models/customer.model';
import { FormControl } from '@angular/forms';
// import { } from 'googlemaps';

import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
    selector: 'add-dealership-branding-modal',
    templateUrl: './add-dealership-branding-modal.component.html',
    styleUrls: ['./add-dealership-branding-modal.component.scss']
})
export class AddDealershipBrandingModalComponent implements OnInit {
    brandName: string = '';
    logoutRedirectUrl: string = '';
    identityServerUrl: string = '';
    undercarriageUrl: string = '';
    undercarriageUiUrl: string = '';
    getUrl: string = '';
    getUiUrl: string = '';
    imageUrl: string = '';
    dealershipId: number = 0;
    dealershipName: string = '';
    selectedColourSchemeId: number = 0;
    ImageFile:File;
    ImageName:string;
    colourSchemes: ColourScheme[] = [];

    savingBrand: boolean = false;
    loadingData: boolean = true;

    constructor(public dialogRef: MatDialogRef<AddDealershipBrandingModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private _dealershipService: DealershipService, private _customerService: CustomerServiceIdentity,
        private ngZone: NgZone, public snackBar: MatSnackBar, private _notifications: NotificationsService) { }

    ngOnInit() {
        if (this.data != null) {
            this.dealershipId = this.data.dealershipId;
            this.dealershipName = this.data.dealershipName;
        }

        this._dealershipService.getAllColourSchemes().subscribe(response => {
            this.colourSchemes = response;
            this.loadingData = false;
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSelectImage(event) {
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();

            reader.readAsDataURL(event.target.files[0]); // read file as data url
        this.ImageFile = event.target.files[0];

          reader.onload = (event: any) => { // called once readAsDataURL is completed
                this.imageUrl = event.target["result"];
                this.ImageName=this.ImageFile.name;
            }
        }
    }

    addNewBrandedStyle() {
        if (this.savingBrand)
            return;
        if (this.brandName.length < 1 || this.selectedColourSchemeId == 0 || this.logoutRedirectUrl.length < 1 || this.identityServerUrl.length < 1 || this.undercarriageUrl.length < 1
            || this.undercarriageUiUrl.length < 1 || this.getUiUrl.length < 1 || this.getUrl.length < 1 || this.imageUrl.length < 1) {
            this.snackBar.open('Please fill in all required fields (*)', '', {
                duration: 1500,
            });
            return;
        }
        this.savingBrand = true;
        let style: BrandedStyleDetails = {
            ColourSchemeId: this.selectedColourSchemeId,
            DealershipId: this.dealershipId,
            GetUiUrl: this.getUiUrl,
            GetUrl: this.getUrl,
            IdentityServerUrl: this.identityServerUrl,
            Id: 0,
            Logo: this.imageUrl,
            LogoutRedirectUrl: this.logoutRedirectUrl,
            Name: this.brandName,
            UndercarriageUiUrl: this.undercarriageUiUrl,
            UndercarriageUrl: this.undercarriageUrl,
            FileName:this.ImageName
        }

        this._dealershipService.addNewBrandedStyle(style).subscribe(response => {
            if (response.m_Item1) {
                this._notifications.success('Added Successfully', 'The branded style has been created successfully. ');
                this.dialogRef.close(true);
            } else {
                this._notifications.error('Failed', response.m_Item2);
            }
        });
    }

}

interface FileReaderEventTarget extends EventTarget {
    result: string
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}
